import React from 'react';
import type { HTMLAttributes } from 'react';
import type { AllIconType } from '../../util/types';
import { getIconComponent } from '../../util/reactFunc';

type Ref = HTMLDivElement;
type HTMLProps = HTMLAttributes<Ref>;
interface Props extends HTMLProps {
  title: string;
  icon: AllIconType;
}

const HeadlineWithIcon = React.forwardRef<Ref, Props>(({
  title,
  icon,
  ...other
}: Props, ref): JSX.Element => (
  <div ref={ref} {...other as HTMLProps}>
    <div className={'flex items-center'}>
      <div className={'-ml-2 mr-2'}>
        {getIconComponent(icon, 'md', 'dark')}
      </div>
      <div className={'font-bold text-xl'}>
        {title}
      </div>
    </div>
  </div>
));

HeadlineWithIcon.displayName = 'HeadlineWithIcon';

export default HeadlineWithIcon;
